/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import {
    IonAlert,
    IonButton,
    IonCol,
    IonContent,
    IonGrid,
    IonItem,
    IonPage,
    IonRow,
    IonTextarea,
    useIonToast,
} from "@ionic/react";
import { useInstallationFeedback } from "../../hooks/useInstallationFeedback";
import { useParams } from "react-router";
import { RatingItem } from "../../components/RatingItem";

import logo from "../../assets/images/logo.svg";
import "./InstallationFeedbackPage.scss";

const InstallationFeedbackPage: React.FC = () => {
    const [showToast] = useIonToast();
    const [showAlert, setShowAlert] = useState<string | null>(null);
    const { hash } = useParams<{ hash: string }>();
    const {
        feedbackOriginallyAvailable,
        feedbackSent,
        fetchInstallationFeedbackIsSent,
        sendInstallationFeedback,
    } = useInstallationFeedback();
    const [q1, setQ1] = useState<number>(0);
    const [q2, setQ2] = useState<number>(0);
    const [q3, setQ3] = useState<number>(0);
    const [q4, setQ4] = useState<number>(0);
    const [q5, setQ5] = useState<string>("");

    useEffect(() => {
        fetchInstallationFeedbackIsSent(hash);
    }, [hash]);

    const handleSendFeedback = async () => {
        if (q1 === 0 || q2 === 0 || q3 === 0 || q4 === 0) {
            showToast({
                message: "Beküldés előtt kérjük értékelje munkánkat!",
                duration: 1000,
                color: "danger",
            });
            return;
        }
        sendInstallationFeedback({
            hash,
            questions: [q1, q2, q3, q4],
            message: q5,
        });
    };

    return (
        <>
            <IonPage>
                <IonContent>
                    <IonGrid
                        className="ion-padding"
                        style={{ paddingBottom: 0 }}
                        fixed
                    >
                        <IonRow>
                            <IonCol
                                size="12"
                                className="ion-col-center-content"
                            >
                                <img
                                    src={logo}
                                    alt="myPatent Logo"
                                    className="desktopLogo"
                                />
                            </IonCol>
                            {/* <IonCol size="12" style={{ textAlign: "center" }}>
                                <h1 className="pageTitle">Visszajelzés</h1>
                            </IonCol> */}
                        </IonRow>
                    </IonGrid>
                    <div className="questions-container-wrapper">
                        <div className=" questions-container">
                            <IonGrid className="questions-grid">
                                {feedbackOriginallyAvailable &&
                                !feedbackSent ? (
                                    <>
                                        <IonRow
                                            style={{ marginBottom: "20px" }}
                                        >
                                            <IonCol
                                                size="12"
                                                style={{ textAlign: "center" }}
                                            >
                                                Megfelelő és teljes körű
                                                tájékoztatást kapott az Ön által
                                                igényelt szolgáltatással
                                                kapcsolatban?
                                                <RatingItem
                                                    value={q1}
                                                    onChange={setQ1}
                                                />
                                            </IonCol>
                                        </IonRow>
                                        <IonRow
                                            style={{ marginBottom: "20px" }}
                                        >
                                            <IonCol
                                                size="12"
                                                style={{ textAlign: "center" }}
                                            >
                                                Elégedett volt a munkatársaink
                                                szakmai hozzáállásával és
                                                munkavégzésével az eszközök
                                                telepítése során?
                                                <RatingItem
                                                    value={q2}
                                                    onChange={setQ2}
                                                />
                                            </IonCol>
                                        </IonRow>
                                        <IonRow
                                            style={{ marginBottom: "20px" }}
                                        >
                                            <IonCol
                                                size="12"
                                                style={{ textAlign: "center" }}
                                            >
                                                Elégedett volt a munkatársaink
                                                segítőkészségével és ügyintézési
                                                folyamatával?
                                                <RatingItem
                                                    value={q3}
                                                    onChange={setQ3}
                                                />
                                            </IonCol>
                                        </IonRow>
                                        <IonRow
                                            style={{ marginBottom: "20px" }}
                                        >
                                            <IonCol
                                                size="12"
                                                style={{ textAlign: "center" }}
                                            >
                                                <div
                                                    style={{
                                                        marginBottom: "10px",
                                                    }}
                                                >
                                                    Ajánlaná a Patent
                                                    szolgáltatásait
                                                    ismerőseinek?
                                                </div>
                                                <RatingItem
                                                    value={q4}
                                                    onChange={setQ4}
                                                />
                                            </IonCol>
                                        </IonRow>
                                        <IonRow
                                            style={{ marginBottom: "20px" }}
                                        >
                                            <IonCol
                                                size="12"
                                                style={{ textAlign: "center" }}
                                            >
                                                <div
                                                    style={{
                                                        marginBottom: "10px",
                                                    }}
                                                >
                                                    Amennyiben szeretné
                                                    észrevételeit bővebben is
                                                    kifejtheti a szövegmezőben.
                                                </div>
                                                <IonItem
                                                    lines="none"
                                                    className="ion-item-textarea"
                                                >
                                                    <IonTextarea
                                                        value={q5}
                                                        onIonChange={(e) =>
                                                            setQ5(
                                                                e.detail.value!
                                                            )
                                                        }
                                                        rows={5}
                                                    ></IonTextarea>
                                                </IonItem>
                                            </IonCol>
                                        </IonRow>
                                        <IonRow>
                                            <IonCol size="12">
                                                <IonButton
                                                    expand="block"
                                                    onClick={handleSendFeedback}
                                                >
                                                    Beküldés
                                                </IonButton>
                                            </IonCol>
                                        </IonRow>
                                    </>
                                ) : (
                                    <>
                                        {!feedbackOriginallyAvailable && (
                                            <h1 style={{ textAlign: "center" }}>
                                                Ön már kitöltötte ezt az
                                                értékelést – köszönjük a
                                                visszajelzését!
                                                <br />
                                                <br />
                                                Ha további észrevétele lenne,
                                                kérjük, vegye fel velünk a
                                                kapcsolatot közvetlenül.
                                            </h1>
                                        )}
                                        {feedbackOriginallyAvailable &&
                                            feedbackSent && (
                                                <h1
                                                    style={{
                                                        textAlign: "center",
                                                    }}
                                                >
                                                    Köszönjük, hogy időt szánt
                                                    ránk és megosztotta velünk a
                                                    véleményét! Nagyon fontos
                                                    számunkra az Ön
                                                    visszajelzése – igyekszünk
                                                    folyamatosan fejlődni és az
                                                    Ön igényeihez igazodni.
                                                    <br />
                                                    <br />
                                                    Ha bármikor további
                                                    észrevétele vagy kérdése
                                                    van, keressen minket
                                                    bizalommal!
                                                </h1>
                                            )}
                                        <br />
                                        <br />
                                        <IonButton
                                            expand="block"
                                            onClick={() =>
                                                window.location.replace(
                                                    "/my/dashboard"
                                                )
                                            }
                                        >
                                            Vissza a főoldalra
                                        </IonButton>
                                    </>
                                )}
                            </IonGrid>
                        </div>
                    </div>
                </IonContent>
            </IonPage>
            <IonAlert
                isOpen={Boolean(showAlert !== null)}
                onDidDismiss={() => setShowAlert(null)}
                header={"Információ"}
                message={showAlert}
                buttons={[
                    {
                        text: "Rendben",
                        role: "cancel",
                    },
                ]}
            />
        </>
    );
};

export default InstallationFeedbackPage;
